import HomeTemplate from '../_shoru_shared_library/template/HomeTemplate';
import AppBar from "../components/AppBar"
import BackgroundImage from '../_media/branding/background.svg';

function Home() {

  return (

    <HomeTemplate 
      appBar={<AppBar />}
      backgroundImage={BackgroundImage}
      tagLine='CastingBot'
      subTagLine='Streamline your auditions. An app for Shoru.'
    />

  )

}

export default Home